import axios from "../axiosInstance";
import { IBranchHierarchyDivisionDto, IBranchDivisionResponse } from "../@types/branchDivision";

export const getBranchDivisions = async () => {
    try {
        let response = await axios.get('/api/branch-hierarchy/divisions');
        const data: IBranchDivisionResponse = response.data;
        return data
    } catch (error) {
        console.error(error)
    }
};

export const updateBranchDivision = async (branchDivision: IBranchHierarchyDivisionDto | undefined) => {
    try {
        if (!branchDivision) return;
        const response = await axios.put('/api/branch-hierarchy/update-branch-division', branchDivision)
        const data: IBranchHierarchyDivisionDto = response.data.branchDivision
        return data
    } catch (error) {
        console.error(error)
    }
};

export const createBranchDivision = async (branchDivision: IBranchHierarchyDivisionDto | undefined) => {
    try {
        if (!branchDivision) return;
        let response = await axios.post('/api/branch-hierarchy/create-branch-division', branchDivision);
        const data: IBranchHierarchyDivisionDto = response.data.branchDivision;
        return data
    } catch (error) {
        console.error(error)
    }
};